import styled from "@emotion/styled";
import { FC, useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Bread } from "../../common/component/Bread";
import { ImageFill } from "../../common/component/ImageFill";
import { RightArrows } from "../../common/component/RightArrows";
import { SuccessStoryEntity } from "../../module/successStory/entity/success.story.entity";
import successStoryService from "../../module/successStory/service/success.story.service";

export const SuccessStoryDetail: FC = () => {
	const [info, setInfo] = useState<SuccessStoryEntity>({});

	const { id } = useParams();
	const navigate = useNavigate();

	const init = useCallback(async () => {
		const { data } = await successStoryService.detail(Number(id));
		setInfo(data);
	}, [id]);

	useEffect(() => {
		window.scrollTo(0, 0);
		init();
	}, [init]);

	const breadArr = [
		{
			title: "成功案例",
		},
		{
			title: info.title,
		},
	];

	return (
		<Container>
			<ImageFill src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/images/2022-05-28/1653669230.jpg"} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>{info.title}</h1>
				</div>
				<Bread value={breadArr} />
				<div className='inner-content'>
					<div dangerouslySetInnerHTML={{ __html: info.description ?? "" }} />
				</div>
				{info.productArr && (
					<div>
						<h2>相关产品</h2>
						{info.productArr.map((item, index) => {
							return (
								<div className='productLink' key={index} onClick={() => navigate(`/product/${item.id}`)}>
									<div>
										<span>产品：</span>
										<b>{item.title}</b>
									</div>
									<div>
										<RightArrows />
									</div>
								</div>
							);
						})}
					</div>
				)}
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.content {
		background: white;
		padding: 1rem;
		z-index: 10;
		position: relative;

		.inner-content {
			margin-top: 0.5rem;
			text-indent: 1rem;

			.ant-image {
				padding: 0.3rem;
				border: 1px solid #ccc;
			}
		}

		.productLink {
			border: 1px solid #ccc;
			padding: 1rem;
			display: flex;
			justify-content: space-between;
			color: #004885;
			cursor: pointer;
		}
	}
`;
